import React, { useEffect } from 'react';
import "../../assets/styles/Profile.css";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import InfoUser from "../../components/Profile/InfoUser.js";
import imgBtnUser from "../../imgs/bt-change-name.png";
import imgBtnUserHover from "../../imgs/bt-change-name-hover.png";
import imgBtnPhone from "../../imgs/bt-change-phone.png";
import imgBtnPhoneHover from "../../imgs/bt-change-phone-hover.png";
import imgBtnMail from "../../imgs/bt-change-mail.png";
import imgBtnMailHover from "../../imgs/bt-change-mail-hover.png";
import imgBtnBank from "../../imgs/bt-change-bank.png";
import imgBtnBankHover from "../../imgs/bt-change-bank-hover.png";
import imgBtnBirthday from "../../imgs/bt-change-birtday.png";
import imgBtnBirthdayHover from "../../imgs/bt-change-birtday-hover.png";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import * as yup from 'yup';


function Profile() {
  const location = useLocation();
  const { userName, data, webSetting } = location.state || {};
  const navigate = useNavigate();

  const schema = yup.object().shape({
    name: yup.string().required('Name is required'),
    email: yup.string().email('Email is invalid').required('Email is required'),
    phoneNumber: yup.string().matches(/^[0-9]+$/, 'Phone number must be digits').required('Phone number is required'),
  });

  const shouldNavigate =(!userName || userName === "undefined");
  useEffect(() => {
    if (shouldNavigate) {
      navigate('/');
    }
  }, [navigate, shouldNavigate]);

  if (!shouldNavigate) {
    const changeInfo = async (typeModal) => {
      if (!userName) {
        return Swal.fire({ icon: "error", text: "Vui lòng nhập tên tài khoản." });
      } else {
        navigate("/change-info",{ state: { userName, data, webSetting, typeModal } });
      }
    };

    return (
      <div className="container">
        <motion.div
          // className="app"
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // transition={{ duration: 5 }}
          // className="app"
          // initial={{ x: "-100vw", opacity: 0 }}
          // animate={{ x: 0, opacity: 1 }}
          // exit={{ x: "100vw", opacity: 0 }}
          // transition={{ type: "spring", stiffness: 100, damping: 20 }}
          className="app"
          initial={{ x: "100vw", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: "-100vw", opacity: 0 }}
          transition={{ type: "spring", stiffness: 1000, damping: 200, duration: 10 }}
        >
          <Header isPageSearch={false} />

          <div className="content">
            <div className="profile">
              {/* <span className="profile-titlte">THÔNG TIN CÁ NHÂN</span>
              <InfoUser /> */}
              <span className="profile-titlte">THAY ĐỔI MỤC THÔNG TIN MỚI</span>
              <div className="action profile-action">
                <div className="action-btn" onClick={() => changeInfo("full_name")}>
                  <img className="img-default" src={imgBtnUser} alt="icon-user" />
                  <img className="img-hover" src={imgBtnUserHover} alt="icon-user" />
                </div>
                <div className="action-btn" onClick={() => changeInfo("phone_number")}>
                  <img className="img-default" src={imgBtnPhone} alt="icon-phone" />
                  <img className="img-hover" src={imgBtnPhoneHover} alt="icon-user" />
                </div>
              </div>
              <div className="action profile-action">
                <div className="action-btn" onClick={() => changeInfo("email")}>
                  <img className="img-default" src={imgBtnMail} alt="icon-mail" />
                  <img className="img-hover" src={imgBtnMailHover} alt="icon-mail" />
                </div>
                <div className="action-btn" onClick={() => changeInfo("bank")}>
                  <img className="img-default" src={imgBtnBank} alt="icon-bank" />
                  <img className="img-hover" src={imgBtnBankHover} alt="icon-bank" />
                </div>
              </div>
              <div className="action-1 profile-action">
                <div className="action-btn" onClick={() => changeInfo("birthday")}>
                  <img className="img-default" src={imgBtnBirthday} alt="icon-mail" />
                  <img className="img-hover" src={imgBtnBirthdayHover} alt="icon-mail" />
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    );
  }
}

export default Profile;
